import React from "react";

const RespirationRateBody = () => {
  return (
    <div>
      <h2>Respiration Rate Body Content</h2>
    </div>
  );
};

export default RespirationRateBody;
